import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SchwaMark extends Mark implements IMark
{
    private isLE:boolean;

    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, isLE:boolean=false, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this.isLE = isLE;
        this._init();
    }

    private _init():void {
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
            this.markX = this.targetTextField.width/2;
            this.markY = this.adjustToScale(80);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const text = "e";
        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 100,
            fill: color,
            align: 'center'
        });
        let mark = new Text({text:text, style:style});
        //const metrics = TextMetrics.measureText(text, style);
        this.markWidth = mark.width;
        this.markHeight = mark.height;
        mark.anchor.set(.5, .5);
        if(this.targetTextField)
        {
            mark.pivot.set(this.markWidth/2, this.markHeight/2);
        }
        else
        {
            mark.x = this.adjustToScale(16);
            mark.y = this.adjustToScale(20);
        }
        mark.scale.set(-1, -1);
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}